import { TableCell, TableRow } from '@ovComponents/2-component/table/table';
import { Box, Button } from 'hephaestus/web';
import { usePortfolioRowDetail } from '../hooks/usePortfolioRowDetail';
import type { PortfolioReport } from '../types';
import { openSubAccountDetails } from '../utils';
import { PortfolioRowDetailAccountBreakdown } from './portfolioRowDetailAccountBreakdown';
import { PortfolioRowDetailGeneralInfo } from './portfolioRowDetailGeneralInfo';
import { PortfolioRowDetailHeader } from './portfolioRowDetailHeader';
import { PortfolioRowDetailPendingTrades } from './portfolioRowDetailPendingTrades';
import { PortfolioRowDetailPositions } from './portfolioRowDetailPositions';

const PortfolioRowDetail = ({
  report,
  onShowTradeBlotter,
  colSpan,
}: {
  report: PortfolioReport;
  onShowTradeBlotter: () => void;
  colSpan: number;
}) => {
  const {
    t,
    theme,
    hasAccountBreakdown,
    hasPositions,
    headerProps,
    generalInfoProps,
    accountBreakdownProps,
    pendingTradesProps,
    positionsProps,
  } = usePortfolioRowDetail(report);

  return (
    <TableRow>
      <TableCell sx={{ py: 0, borderBottom: 'none' }} colSpan={colSpan}>
        <Box sx={{ py: 1.5, px: 2, backgroundColor: theme.color.neutralHover }}>
          <PortfolioRowDetailHeader {...headerProps} />

          <Box
            sx={{
              display: 'grid',

              gridTemplateColumns: {
                xs: '1fr',
                md: hasAccountBreakdown ? '1fr 1.2fr' : '1fr',
              },

              gap: 2,
              mb: 2,
            }}
          >
            <PortfolioRowDetailGeneralInfo {...generalInfoProps} />
            {hasAccountBreakdown && (
              <PortfolioRowDetailAccountBreakdown {...accountBreakdownProps} />
            )}
          </Box>

          <PortfolioRowDetailPendingTrades {...pendingTradesProps} />

          {hasPositions && <PortfolioRowDetailPositions {...positionsProps} />}

          <Box
            sx={{
              display: 'flex',
              gap: 1,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant='outlined'
              size='small'
              onClick={() => openSubAccountDetails(report)}
            >
              {t('rowDetail.actions.viewDetails')}
            </Button>
            <Button
              variant='contained'
              size='small'
              onClick={onShowTradeBlotter}
            >
              {t('rowDetail.actions.generateTrades')}
            </Button>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default PortfolioRowDetail;
